import { styled } from '@mui/system'

export const OmnibusPriceWrapper = styled('div')`
	margin-top: ${({ theme }) => theme.spacing(1)};

	.omnibus-price {
		font-family: ${({ theme }) => theme.typography.caption.fontFamily};
		font-size: ${({ theme }) => theme.typography.caption.fontSize};
		font-weight: ${({ theme }) => theme.typography.caption.fontWeight};
		line-height: ${({ theme }) => theme.typography.caption.lineHeight};
		color: ${({ theme }) => theme.palette.grey.main};
	}
`
